/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import SelectCountryCode from "../components/modals/select-country-code";
import { SelectTerritory } from "../components/modals/select-territory";
import axios from "axios";
import StoreFooter from "../components/store/store-footer";

export default function StoreRegister() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [countryCode, setCountryCode] = useState("971");
    const [isCountryCodeSelecting, setIsCountryCodeSelecting] = useState(false);
    const [territory, setTerritory] = useState<string | null>(null);
    const [territoryName, setTerritoryName] = useState<string>(
        "UAE available for delivery",
    );
    const [isTerritorySelecting, setIsTerritorySelecting] = useState(false);
    const [mobile, setMobile] = useState("");

    const [companyName, setCompanyName] = useState("");
    const [email, setEmail] = useState("");
    const [companyActivity, setCompanyActivity] = useState("");
    const [companyProfile, setCompanyProfile] = useState("");
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    // Play Store and App Store URL
    const appStoreURL =
        "https://apps.apple.com/ae/app/z-shops/id6475626069";
    const playStoreURL =
        "https://play.google.com/store/apps/details?id=com.zabehatyshopapp";

    useEffect(() => {
        if (mobileOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    }, [mobileOpen]);

    const handleSubmit = async () => {
        if (
            !companyName ||
            !mobile ||
            !email ||
            !companyActivity ||
            !companyProfile ||
            !imageFile ||
            !territory
        ) {
            alert("Please fill all fields and select territory + upload image");
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("name", companyName);
        formData.append("mobile", mobile);
        // formData.append("country_code", countryCode);
        formData.append("email", email);
        formData.append("work_type", companyActivity);
        formData.append("bio", companyProfile);
        formData.append("emirate_id[]", territory);

        formData.append("image", imageFile);

        try {
            const response = await axios.post("/regsiter-store", formData);
            if (response.data.status === 200 || response.data.status === 201) {
                // alert("Store registered successfully");
                // Reset form
                setCompanyName("");
                setMobile("");
                setEmail("");
                setCompanyActivity("");
                setCompanyProfile("");
                setImageFile(null);
                setTerritory(null);
                setTerritoryName("UAE available for delivery");
            } else {
                alert("Error: " + response.data.msg || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            alert("Failed to submit");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {" "}
            <Helmet>
                {/* <title>Zabehaty - Fresh Halal Meat Store</title>
                <meta
                    name="description"
                    content="Zabehaty offers fresh, halal meat with excellent quality and trusted service in UAE."
                />
                <meta
                    name="keywords"
                    content="Halal meat, fresh meat, Zabehaty, meat store, UAE, sacrificial meat"
                />
                <meta name="author" content="Zabehaty" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <link rel="canonical" href="https://zabehaty.com/store" /> */}

                {/* Open Graph / Facebook */}
                {/* <meta
                    property="og:title"
                    content="Zabehaty - Store (Portfolio)"
                />
                <meta
                    property="og:description"
                    content="Zabehaty offers fresh, halal meat with excellent quality and trusted service in UAE."
                />
                <meta
                    property="og:image"
                    content="https://zabehaty.com/landingpage_banner1.jpg"
                />
                <meta property="og:url" content="https://zabehaty.com/store" />
                <meta property="og:type" content="website" /> */}

                {/* Twitter */}
                {/* <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Zabehaty - Fresh Halal Meat Store"
                />
                <meta
                    name="twitter:description"
                    content="Zabehaty offers fresh, halal meat with excellent quality and trusted service in UAE."
                />
                <meta
                    name="twitter:image"
                    content="https://zabehaty.com/landingpage_banner1.jpg"
                />
                <meta name="twitter:site" content="@YourTwitterHandle" /> */}
            </Helmet>
            <div className="font-sans antialiased">
                {/* Hero */}
                <header className="absolute left-0 top-8 z-50 flex w-full items-center justify-between px-8">
                    {/* Logo */}
                    <img
                        src="/store/store_logos/logo1.svg"
                        alt="Logo 1"
                        className="h-24 object-contain"
                    />

                    {/* Desktop Menu */}
                    <div className="hidden space-x-8 md:flex">
                        <a
                            href="/store"
                            className="text-lg text-white hover:underline"
                        >
                            Home
                        </a>

                        {/* Language Dropdown */}
                        <div className="group relative">
                            <button className="text-lg text-white hover:underline">
                                Language
                            </button>
                            <div className="invisible absolute left-0 mt-2 w-[240px] bg-white p-4 opacity-0 shadow-lg transition group-hover:visible group-hover:opacity-100">
                                <a
                                    href="#"
                                    className="block px-4 py-2 text-lg text-black hover:bg-[#01E784] hover:text-white"
                                >
                                    Arabic
                                </a>
                                <a
                                    href="#"
                                    className="block px-4 py-2 text-lg text-black hover:bg-[#01E784] hover:text-white"
                                >
                                    English
                                </a>
                                <a
                                    href="#"
                                    className="block px-4 py-2 text-lg text-black hover:bg-[#01E784] hover:text-white"
                                >
                                    Urdu
                                </a>
                            </div>
                        </div>

                        <a
                            href="/store/register"
                            className="text-lg text-white underline hover:underline"
                        >
                            Register Store
                        </a>
                        <a
                            href="/store/articles"
                            className="text-lg text-white hover:underline"
                        >
                            Article
                        </a>
                    </div>

                    {/* Desktop Contact Button */}
                    <div className="hidden flex-row items-center rounded px-6 py-3 font-semibold text-white transition md:flex">
                        <a
                            href={appStoreURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block"
                        >
                            <img
                                src="/appstore_icon.svg"
                                alt="Zabehaty App Store Icon"
                                className="object-contain"
                            />
                        </a>
                        <a
                            href={playStoreURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block"
                        >
                            <img
                                src="/playstore_icon.svg"
                                alt="Zabehaty Play Store Icon"
                                className="object-contain"
                            />
                        </a>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setMobileOpen(true)}
                            className="text-2xl text-white"
                        >
                            ☰
                        </button>
                    </div>
                </header>

                {/* Hero Section */}
                <section
                    className="relative flex flex-col items-center justify-center text-white"
                    style={{
                        backgroundImage: `url('/storeregister_banner.jpg')`,
                        minHeight: "400px",
                        width: "100%",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                    }}
                >
                    {/* Dark overlay */}
                    <div className="absolute inset-0 bg-black bg-opacity-30"></div>

                    {/* Center Banner - stays bright */}
                    <img
                        src="/storeregister_text.png"
                        alt="Zabehaty - Register Store"
                        className="relative z-10 h-auto w-3/4 pt-8 sm:w-1/2 lg:w-2/5"
                    />
                </section>

                {/* Mobile Menu Drawer - rendered at root level */}
                {mobileOpen && (
                    <div className="fixed inset-0 z-[9999] flex flex-col space-y-6 bg-white p-8 text-black">
                        <button
                            onClick={() => setMobileOpen(false)}
                            className="self-end text-3xl"
                        >
                            ✕
                        </button>

                        <a
                            href="/store"
                            onClick={() => setMobileOpen(false)}
                            className="font-semibold"
                        >
                            Home
                        </a>

                        {/* Language dropdown for mobile */}
                        <div>
                            <div className="mb-2 font-bold">Language</div>
                            <div className="flex flex-col space-y-2">
                                <a
                                    href="#"
                                    onClick={() => setMobileOpen(false)}
                                >
                                    English
                                </a>
                                <a
                                    href="#"
                                    onClick={() => setMobileOpen(false)}
                                >
                                    Arabic
                                </a>
                                <a
                                    href="#"
                                    onClick={() => setMobileOpen(false)}
                                >
                                    Urdu
                                </a>
                            </div>
                        </div>

                        <a
                            href="/store/register"
                            onClick={() => setMobileOpen(false)}
                            className="font-semibold"
                        >
                            {" "}
                            Register Store
                        </a>

                        <div className="hidden flex-row items-center rounded bg-gray-500 px-6 py-3 font-semibold text-white transition md:flex">
                            <svg
                                className="transition ease-in-out hover:scale-110"
                                width="55"
                                height="55"
                                viewBox="0 0 68 68"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <foreignObject
                                    x="-7.04654"
                                    y="-11.0485"
                                    width="82.1009"
                                    height="82.1009"
                                >
                                    <div
                                        // eslint-disable-next-line react/style-prop-object
                                        style={{
                                            backdropFilter: "blur(5.53px)",
                                            clipPath:
                                                "url(#bgblur_0_350_1470_clip_path)",
                                            height: "100%",
                                            width: "100%",
                                        }}
                                    ></div>
                                </foreignObject>
                                <g
                                    filter="url(#filter0_d_350_1470)"
                                    data-figma-bg-blur-radius="11.0504"
                                >
                                    <rect
                                        x="4.00391"
                                        y="0.00195312"
                                        width="60"
                                        height="60"
                                        fill="white"
                                        fill-opacity="0.1"
                                        shape-rendering="crispEdges"
                                    />
                                    <rect
                                        x="4.50391"
                                        y="0.501953"
                                        width="59"
                                        height="59"
                                        stroke="white"
                                        shape-rendering="crispEdges"
                                    />
                                    <g clip-path="url(#clip1_350_1470)">
                                        <path
                                            d="M38.7895 18.0662C38.6231 17.4456 38.2252 16.9269 37.6688 16.6057C36.5205 15.9426 35.0465 16.3374 34.3833 17.4861L34.0131 18.1273L33.6428 17.486C32.9797 16.3376 31.5058 15.9426 30.3573 16.6056C29.2087 17.2688 28.8138 18.7426 29.4769 19.8913L31.2357 22.9376L24.746 34.1782H20.0146C18.6884 34.1782 17.6094 35.2572 17.6094 36.5835C17.6094 37.9097 18.6884 38.9887 20.0146 38.9887H38.2809L35.5035 34.1782H30.3006L38.5491 19.8914C38.8704 19.335 38.9558 18.6867 38.7895 18.0662Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M48.0124 34.1781H43.281L37.9023 24.8618L35.125 29.6723L43.4763 44.1371C43.7976 44.6936 44.3162 45.0916 44.9369 45.258C45.1441 45.3135 45.3544 45.341 45.5633 45.341C45.9801 45.341 46.3915 45.2317 46.7622 45.0177C47.9107 44.3545 48.3056 42.8806 47.6424 41.7321L46.0583 38.9886H48.0124C49.3387 38.9886 50.4177 37.9096 50.4177 36.5834C50.4177 35.2571 49.3387 34.1781 48.0124 34.1781Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M20.8572 40.9128L20.3842 41.732C19.7212 42.8804 20.1161 44.3541 21.2644 45.017C21.6422 45.2351 22.0551 45.3388 22.4628 45.3387C23.2945 45.3387 24.1046 44.9074 24.5496 44.1368L26.4109 40.9128H20.8572Z"
                                            fill="white"
                                        />
                                    </g>
                                </g>
                                <defs>
                                    <filter
                                        id="filter0_d_350_1470"
                                        x="-7.04654"
                                        y="-11.0485"
                                        width="82.1009"
                                        height="82.1009"
                                        filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB"
                                    >
                                        <feFlood
                                            flood-opacity="0"
                                            result="BackgroundImageFix"
                                        />
                                        <feColorMatrix
                                            in="SourceAlpha"
                                            type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                            result="hardAlpha"
                                        />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite
                                            in2="hardAlpha"
                                            operator="out"
                                        />
                                        <feColorMatrix
                                            type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                        />
                                        <feBlend
                                            mode="normal"
                                            in2="BackgroundImageFix"
                                            result="effect1_dropShadow_350_1470"
                                        />
                                        <feBlend
                                            mode="normal"
                                            in="SourceGraphic"
                                            in2="effect1_dropShadow_350_1470"
                                            result="shape"
                                        />
                                    </filter>
                                    <clipPath
                                        id="bgblur_0_350_1470_clip_path"
                                        transform="translate(7.04654 11.0485)"
                                    >
                                        <rect
                                            x="4.00391"
                                            y="0.00195312"
                                            width="60"
                                            height="60"
                                        />
                                    </clipPath>
                                    <clipPath id="clip1_350_1470">
                                        <rect
                                            width="33.8146"
                                            height="33.8146"
                                            fill="white"
                                            transform="translate(17.1094 13.9043)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg
                                className="transition ease-in-out hover:scale-110"
                                width="55"
                                height="55"
                                viewBox="0 0 68 68"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <foreignObject
                                    x="-7.26205"
                                    y="-11.2621"
                                    width="82.528"
                                    height="82.528"
                                >
                                    <div
                                        // eslint-disable-next-line react/style-prop-object
                                        style={{
                                            backdropFilter: "blur(5.63px)",
                                            clipPath:
                                                "url(#bgblur_0_350_1471_clip_path)",
                                            height: "100%",
                                            width: "100%",
                                        }}
                                    ></div>
                                </foreignObject>
                                <g
                                    filter="url(#filter0_d_350_1471)"
                                    data-figma-bg-blur-radius="11.266"
                                >
                                    <rect
                                        x="4.00391"
                                        y="0.00390625"
                                        width="59.9961"
                                        height="59.9961"
                                        fill="white"
                                        fill-opacity="0.1"
                                        shape-rendering="crispEdges"
                                    />
                                    <rect
                                        x="4.50391"
                                        y="0.503906"
                                        width="58.9961"
                                        height="58.9961"
                                        stroke="white"
                                        shape-rendering="crispEdges"
                                    />
                                    <g clip-path="url(#clip1_350_1471)">
                                        <path
                                            d="M19.9165 15.4465C19.5084 15.9858 19.2812 16.6492 19.2812 17.3592V45.4597C19.2812 46.1191 19.4779 46.7386 19.8332 47.2561L35.1229 31.3079L19.9165 15.4465Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M36.52 29.8475L41.4802 24.6738L24.0445 14.6074C23.2878 14.1704 22.4195 14.0668 21.6094 14.2945L36.52 29.8475Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M36.5222 32.7683L21.4609 48.4783C21.7857 48.5874 22.1217 48.6423 22.458 48.6423C23.0036 48.6423 23.5495 48.4988 24.0467 48.2116L41.6078 38.0727L36.5222 32.7683Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M48.3819 28.6577L43.2844 25.7146L37.9219 31.3077L43.4095 37.032L48.3819 34.1612C49.3768 33.5869 49.9708 32.558 49.9708 31.4095C49.9708 30.2607 49.3768 29.232 48.3819 28.6577Z"
                                            fill="white"
                                        />
                                    </g>
                                </g>
                                <defs>
                                    <filter
                                        id="filter0_d_350_1471"
                                        x="-7.26205"
                                        y="-11.2621"
                                        width="82.528"
                                        height="82.528"
                                        filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB"
                                    >
                                        <feFlood
                                            flood-opacity="0"
                                            result="BackgroundImageFix"
                                        />
                                        <feColorMatrix
                                            in="SourceAlpha"
                                            type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                            result="hardAlpha"
                                        />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite
                                            in2="hardAlpha"
                                            operator="out"
                                        />
                                        <feColorMatrix
                                            type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                        />
                                        <feBlend
                                            mode="normal"
                                            in2="BackgroundImageFix"
                                            result="effect1_dropShadow_350_1471"
                                        />
                                        <feBlend
                                            mode="normal"
                                            in="SourceGraphic"
                                            in2="effect1_dropShadow_350_1471"
                                            result="shape"
                                        />
                                    </filter>
                                    <clipPath
                                        id="bgblur_0_350_1471_clip_path"
                                        transform="translate(7.26205 11.2621)"
                                    >
                                        <rect
                                            x="4.00391"
                                            y="0.00390625"
                                            width="59.9961"
                                            height="59.9961"
                                        />
                                    </clipPath>
                                    <clipPath id="clip1_350_1471">
                                        <rect
                                            width="34.3975"
                                            height="34.4648"
                                            fill="white"
                                            transform="translate(17.3633 14.1772)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                )}

                {/* Register Here */}
                <section className="mx-auto max-w-2xl px-6 pb-10 pt-8">
                    <h3 className="mb-6 text-left text-3xl ">
                        <strong>Register</strong> Here
                    </h3>
                    <form
                        className="flex flex-col gap-4"
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <input
                            value={companyName}
                            type="text"
                            placeholder="Company or Store Name"
                            className="rounded border border-gray-200 bg-[#E8E8E8] px-4 py-4"
                            onChange={(e) => setCompanyName(e.target.value)}
                        />
                        <div className="flex items-center gap-2 rounded border border-gray-200 bg-[#E8E8E8] px-4 py-4">
                            <input
                                type="text"
                                value={mobile}
                                className="flex-1 bg-transparent placeholder-gray-400 focus:outline-none"
                                placeholder="Mobile Number"
                                onChange={(e) => setMobile(e.target.value)}
                            />
                            <button
                                className="flex items-center transition hover:opacity-80"
                                onClick={() => setIsCountryCodeSelecting(true)}
                            >
                                +{countryCode}
                                <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_258_154458)">
                                        <path
                                            d="M4.66516 5.86704L6.10796 7.55893C6.32521 7.81369 6.67616 7.81369 6.89342 7.55893L8.33622 5.86704C8.68717 5.4555 8.43649 4.75 7.9407 4.75H5.0551C4.55931 4.75 4.31421 5.4555 4.66516 5.86704Z"
                                            fill="#525252"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_258_154458">
                                            <rect
                                                width="11.5"
                                                height="11.5"
                                                fill="white"
                                                transform="translate(0.5 0.5)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button>
                        </div>
                        <input
                            value={email}
                            type="email"
                            placeholder="Your Email"
                            className="rounded border border-gray-200 bg-[#E8E8E8] px-4 py-4"
                            onChange={(e) =>
                                setEmail((e.target as HTMLInputElement).value)
                            }
                        />
                        <div className="flex cursor-pointer items-center justify-center gap-2 rounded border border-gray-200 bg-[#E8E8E8] px-4 py-12">
                            <input
                                type="file"
                                accept="image/*"
                                id="imageUpload"
                                className="hidden"
                                onChange={(e) => {
                                    if (e.target.files?.[0]) {
                                        setImageFile(e.target.files[0]);
                                    }
                                }}
                            />

                            {/* Group label + icon */}
                            <label
                                htmlFor="imageUpload"
                                className="flex cursor-pointer items-center gap-2 text-gray-600"
                            >
                                Commercial Registry Image
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#01E784"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M12 5v14M5 12h14" />
                                </svg>
                            </label>
                            {imageFile && (
                                <img
                                    src={URL.createObjectURL(imageFile)}
                                    alt="Selected"
                                    className="h-32 w-32 rounded object-cover"
                                />
                            )}
                        </div>
                        <input
                            value={companyActivity}
                            type="text"
                            placeholder="Company Activity"
                            className="rounded border border-gray-200 bg-[#E8E8E8] px-4 py-4"
                            onChange={(e) => setCompanyActivity(e.target.value)}
                        />

                        <input
                            value={companyProfile}
                            type="text"
                            placeholder="Company Profile"
                            className="rounded border border-gray-200 bg-[#E8E8E8] px-4 py-4"
                            onChange={(e) => setCompanyProfile(e.target.value)}
                        />
                        <div className="flex items-center gap-2 rounded border border-gray-200 bg-[#E8E8E8] px-4 py-4">
                            <button
                                type="button"
                                onClick={() => setIsTerritorySelecting(true)}
                                className="flex-1 text-left text-gray-700"
                            >
                                {territoryName}
                            </button>
                        </div>

                        <p className="py-2 text-center text-sm text-gray-500">
                            Your registration of data on the Zabehati
                            application is an implied consent to{" "}
                            <span className="text-[#01E784]">
                                Terms and Condition's
                            </span>
                        </p>

                        <button
                            type="button"
                            onClick={handleSubmit}
                            className="w-24 self-center rounded bg-[#01E784] px-6 py-3 text-center font-semibold text-white transition"
                        >
                            Save
                        </button>
                    </form>
                </section>

                {/* Footer */}
                <StoreFooter />
            </div>
            {isCountryCodeSelecting && (
                <div className="ReactModal__Overlay ReactModal__Overlay--after-open fixed">
                    <div className="ReactModal__Content ReactModal__Content--after-open bg-white">
                        <div className="flex flex-col">
                            <div className="mb-4 flex">
                                <button
                                    className="ms-auto transition hover:scale-125"
                                    onClick={() =>
                                        setIsCountryCodeSelecting(false)
                                    }
                                >
                                    <svg
                                        width="32"
                                        height="33"
                                        viewBox="0 0 32 33"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M8.07975 8.43587C8.70459 7.81103 9.71765 7.81103 10.3425 8.43587L15.9993 14.0927L21.6562 8.43587C22.281 7.81103 23.2941 7.81103 23.9189 8.43587C24.5438 9.06071 24.5438 10.0738 23.9189 10.6986L18.2621 16.3555L23.9189 22.0123C24.5438 22.6372 24.5438 23.6502 23.9189 24.2751C23.2941 24.8999 22.281 24.8999 21.6562 24.2751L15.9993 18.6182L10.3425 24.2751C9.71765 24.8999 8.70459 24.8999 8.07975 24.2751C7.45491 23.6502 7.45491 22.6372 8.07975 22.0123L13.7366 16.3555L8.07975 10.6986C7.45491 10.0738 7.45491 9.06071 8.07975 8.43587Z"
                                            fill="#262626"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <SelectCountryCode
                                setCountryCode={setCountryCode}
                                countryCode={countryCode}
                                setIsCountryCodeSelecting={
                                    setIsCountryCodeSelecting
                                }
                            />
                        </div>
                    </div>
                </div>
            )}
            {isTerritorySelecting && (
                <div className="ReactModal__Overlay ReactModal__Overlay--after-open fixed inset-0 flex items-center justify-center bg-black/50">
                    <div className="ReactModal__Content ReactModal__Content--after-open w-[90%] max-w-md rounded-xl bg-white p-6">
                        <div className="flex flex-col">
                            {/* Close button */}
                            <div className="mb-4 flex">
                                <button
                                    className="ms-auto transition hover:scale-125"
                                    onClick={() =>
                                        setIsTerritorySelecting(false)
                                    }
                                >
                                    <svg
                                        width="32"
                                        height="33"
                                        viewBox="0 0 32 33"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M8.07975 8.43587C8.70459 7.81103 9.71765 7.81103 10.3425 8.43587L15.9993 14.0927L21.6562 8.43587C22.281 7.81103 23.2941 7.81103 23.9189 8.43587C24.5438 9.06071 24.5438 10.0738 23.9189 10.6986L18.2621 16.3555L23.9189 22.0123C24.5438 22.6372 24.5438 23.6502 23.9189 24.2751C23.2941 24.8999 22.281 24.8999 21.6562 24.2751L15.9993 18.6182L10.3425 24.2751C9.71765 24.8999 8.70459 24.8999 8.07975 24.2751C7.45491 23.6502 7.45491 22.6372 8.07975 22.0123L13.7366 16.3555L8.07975 10.6986C7.45491 10.0738 7.45491 9.06071 8.07975 8.43587Z"
                                            fill="#262626"
                                        />
                                    </svg>
                                </button>
                            </div>

                            <SelectTerritory
                                territory={territory}
                                setTerritory={(id: string) => setTerritory(id)}
                                setIsTerritorySelecting={
                                    setIsTerritorySelecting
                                }
                                setTerritoryName={setTerritoryName}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
